import React from "react";
const SpeedAvg = () => {
  return <div> SpeedAvg</div>;
};
export default SpeedAvg;
